/* eslint-disable max-params */
/* eslint-disable complexity */
/* eslint-disable max-statements */
import { COUNTRY } from "../../constants/app-constants";
import { appUrl } from "../../constants/url-constants";
import { FILTER_ENTITIES } from "../filters-v2/constants";
import capitalize from "./capitalize";

// Array of filter entities for category pages
const categoryPagesBreadcrumbs = [
    FILTER_ENTITIES.BODY_TYPE,
    FILTER_ENTITIES.MAKE,
    FILTER_ENTITIES.FUEL_TYPE,
    FILTER_ENTITIES.TRANSMISSION
];

// to create path text for city-based paths
const createCityPathText = (isCityPath, city, {make = "", model = ""} = {}) => {
    // city path
    city = capitalize(city);
    make = capitalize(make);
    model = model ? capitalize(model) : null;
    if (isCityPath) {
        return city ? `Used Cars in ${city}` : null;
    } else if (city) {
        // breadcrumb name for make + model + city
        return city && make && model ? `Used ${make} ${model} in ${city}` : `Used ${make} in ${city}`;
    }
    return "";
};

//  to create path text for country-based paths
const createCountryPathText = (isCategory, isMake, option) => {
    if (isMake) {
        return option ?  `Used ${option} in Australia` : "";
    } else if (isCategory) {
        return option ? `Used ${option} Cars in Australia` : "";
    } else if (option.match(/under|above|between/)) {
        option = option.replace("aud", "Aud");
        return `Used Cars ${option} in Australia`;
    }
    return "";
};

const repalceSpaceWithHyphen = (str = "") => (/\s/).test(str) ? str.replaceAll(" ", "-") : (str || "");

const buildUrl = (base, path) => path ? `${base}/${path.toLowerCase()}/` : "";

const isFilterEntityPresent = (appliedFilters, entity) => {
    if (appliedFilters && appliedFilters.length > 0) {
        return appliedFilters.some((filter) => filter.filterKey === entity);
    } else {
        return false;
    }
};

const isAnyFilterEntityPresent = (appliedFilters, entities) => {
    return entities.some(entity => isFilterEntityPresent(appliedFilters, entity));
};

const getAppliedFilterDetail = (appliedFilters, filterKey) => {
    return appliedFilters.filter((filter) => filter.filterKey === filterKey);
};

const getSpathDetails = ({ appliedFilters = [], selectedCity = {}, currentUrl = "" }) => {
    const { optionKey, subOptionKey = "" } = appliedFilters[0] || {};
    const { name = "" } = selectedCity || {};
    let pathText1 = "";
    let url1 = "";
    let pathText2 = "";
    let url2 = "";
    let pathText3 = "";
    let url3 = "";

    // Check if the current URL matches a price range filter
    if (currentUrl.match(/under|above|between/)) {
        pathText1 = currentUrl.replace("/buy-used-", "").replace(/-/g, " ").replace("/", "");
        pathText1 = createCountryPathText(false, false, pathText1);
    } else if (COUNTRY.slug !== name.toLowerCase()) {
        pathText1 = createCityPathText(true, name);
    }

    // Check if the MAKECITYNAME filter is present
    if (isFilterEntityPresent(appliedFilters, FILTER_ENTITIES.MAKECITYNAME)) {
        pathText1 = subOptionKey || ""; // location
        url1 = buildUrl(appUrl(), `buy-used-cars-in-${pathText1}`);
        pathText2 = optionKey || ""; // make
        pathText2 = createCityPathText(false, pathText1, { make: pathText2 });
        pathText1 = createCityPathText(true, pathText1); // updating pathText1 after pathText2 because 2 is dependent on initial value of 1
    } else if (
        isFilterEntityPresent(appliedFilters, FILTER_ENTITIES.CITYNAME) &&
        isAnyFilterEntityPresent(appliedFilters, [FILTER_ENTITIES.MAKE, FILTER_ENTITIES.MODELCITYNAME])
    ) {
        // Check if the CITYNAME filter and either MAKE or MODELCITYNAME filters are present
        const selectedMakeOrModel = isFilterEntityPresent(appliedFilters, FILTER_ENTITIES.MODELCITYNAME)
            ? getAppliedFilterDetail(appliedFilters, FILTER_ENTITIES.MODELCITYNAME)
            : getAppliedFilterDetail(appliedFilters, FILTER_ENTITIES.MAKE);

        const selectedMakeModel = selectedMakeOrModel?.[0];

        const cityPath = getAppliedFilterDetail(appliedFilters, FILTER_ENTITIES.CITYNAME)?.[0].optionKey || "";
        const makePath = selectedMakeModel.optionKey || "";
        const modelPath = selectedMakeModel.subOptionKey || "";

        pathText1 = cityPath;
        pathText2 = repalceSpaceWithHyphen(makePath);
        pathText3 = modelPath;

        url1 = buildUrl(appUrl(), `buy-used-cars-in-${pathText1}`);
        url2 = buildUrl(appUrl(), `buy-used-${pathText2}-cars-in-${pathText1}`);
        url3 = buildUrl(appUrl(), `buy-used-${pathText2}-${pathText3}-in-${pathText1}`);

        pathText3 = createCityPathText(false, cityPath, { make: makePath, model: modelPath });
        pathText2 = createCityPathText(false, cityPath, { make: makePath });
        pathText1 = createCityPathText(true, cityPath);
        return {
            pathText1,
            url1,
            pathText2,
            url2,
            pathText3,
            url3
        };
    } else if (
        isAnyFilterEntityPresent(appliedFilters, categoryPagesBreadcrumbs)
    ) {
        // Check if any category page filters are present
        const currentFilter = appliedFilters.find(filter =>
            categoryPagesBreadcrumbs.includes(filter.filterKey)
        );
        pathText1 = repalceSpaceWithHyphen(currentFilter?.optionKey);

        url1 = buildUrl(appUrl(), `buy-used-${pathText1}`);
        pathText2 = appliedFilters.length === 1 ? currentFilter?.subOptionKey : "";
        url2 = buildUrl(appUrl(), `buy-used-${pathText1}-${pathText2}`);

        if (
            isAnyFilterEntityPresent(appliedFilters, [FILTER_ENTITIES.FUEL_TYPE, FILTER_ENTITIES.TRANSMISSION])
        ) {
            pathText1 = createCountryPathText(true, false, pathText1);
            pathText2 = appliedFilters.length === 1 ? createCountryPathText(true, false, pathText2) : "";
        } else {
            pathText1 = createCountryPathText(false, true, pathText1);
            pathText2 = appliedFilters.length === 1 ? createCountryPathText(false, true, pathText2) : "";
        }
    }
    return {
        pathText1,
        url1,
        pathText2,
        url2
    };
};

export {
    getSpathDetails
};
